import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import pxToRem from "assets/theme/functions/pxToRem";

const { grey, text, primary } = colors;
const { borderRadius, borderWidth } = borders;

const input = {
  styleOverrides: {
    root: {
      fontSize: pxToRem(14),
      color: text.main,
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: `${borderWidth[1]} solid ${grey[400]}`,
      },
      "&:before": {
        borderColor: grey[300],
      },
      "&:after": {
        borderColor: primary.main,
      },
    },
  },
};

const inputOutlined = {
  styleOverrides: {
    root: {
      borderRadius: borderRadius.md,
      fontSize: pxToRem(14),
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: grey[300],
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: grey[400],
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: primary.main,
        borderWidth: borderWidth[2],
      },
    },
    input: {
      padding: `${pxToRem(10)} ${pxToRem(14)}`,
    },
  },
};

const inputLabel = {
  styleOverrides: {
    root: {
      fontSize: pxToRem(14),
      color: text.secondary,
      "&.Mui-focused": { color: primary.main },
    },
  },
};

const textField = {
  styleOverrides: {
    root: {},
  },
};

const select = {
  styleOverrides: {
    select: {
      display: "flex",
      alignItems: "center",
      padding: `${pxToRem(10)} ${pxToRem(14)}`,
    },
  },
};

const autocomplete = {
  styleOverrides: {
    popper: { boxShadow: "0 10px 15px -3px rgba(28, 25, 23, 0.1)" },
    paper: { borderRadius: borderRadius.lg, border: `1px solid ${grey[200]}` },
    option: { fontSize: pxToRem(14), padding: `${pxToRem(8)} ${pxToRem(16)}` },
  },
};

const checkbox = {
  styleOverrides: {
    root: { color: grey[400], "&.Mui-checked": { color: primary.main } },
  },
};

const radio = {
  styleOverrides: {
    root: { color: grey[400], "&.Mui-checked": { color: primary.main } },
  },
};

const switchButton = {
  styleOverrides: {
    root: {},
    switchBase: {
      "&.Mui-checked": { color: primary.main },
      "&.Mui-checked + .MuiSwitch-track": { backgroundColor: primary.light, opacity: 0.5 },
    },
  },
};

const formControlLabel = {
  styleOverrides: {
    root: { marginLeft: 0 },
    label: { fontSize: pxToRem(14), color: text.main },
  },
};

const formLabel = {
  styleOverrides: {
    root: { color: text.secondary },
  },
};

export {
  input,
  inputOutlined,
  inputLabel,
  textField,
  select,
  autocomplete,
  checkbox,
  radio,
  switchButton,
  formControlLabel,
  formLabel,
};
